import BigNumber from 'bignumber.js'
import { Serialize, Numeric } from 'eosjs'
import Amax from '@amax/amaxjs'
import moment from 'moment'
import _service from '@/service'
import { isStarNest, saveImage, webviewClose } from './starnest'
import { showToast } from 'vant'
import { useRouter } from 'vue-router'
const { format } = Amax.modules
export declare interface  LoginToken {
  userId?: number;
  accessToken: string;
  refreshToken?: string;
  expiresTime?: number;
  openid?: any;
  account: string;
}

export type coinType = {
  code: string
  coin: string
  balance: string
  precision: number
}

export const isProd = import.meta.env.VITE_APP_NET === "production";
export const isDev = import.meta.env.MODE === "development";

/**
 * 帐号转bigNumber
 * @param {*} accountName
 * @returns
 */
export const nameToNumeric = (accountName: any) =>
  format.encodeName(accountName, false)

/**
 * bigNumber转帐号
 * @param {*} accountName
 * @returns
 */
export const numerToNameic = (accountName: any) =>
    format.decodeName(accountName, false)

// 生成随机UUID
export const makeUUID = () => {
  const chars = '0123456789'.split('')
  const radix = chars.length
  const uuid = []
  // eslint-disable-next-line
  for (let i = 0; i < 16; i++) uuid[i] = chars[0 | Math.random() * radix]
  return uuid.join('')
}

// 生成随机id
export const makeID = () => {
  const chars = '0123456789'.split('')
  const radix = chars.length
  const uuid = []
  // eslint-disable-next-line
  for (let i = 0; i < 5; i++) uuid[i] = chars[0 | Math.random() * radix]
  return uuid.join('')
}


export const $BigNumber = (val: string | number = 1) => {
  return new BigNumber(val)
}

export const $shiftedBy = (data: number, acc: number) => {
  if (!data) return 0
  acc = Number(acc)
  return $BigNumber(data).shiftedBy(acc)
}

export const $toFixed = (data: any, acc: number) => {
  if ((!data && data !== 0) || String(data).includes('--')) return '--'
  return Number($BigNumber(data).toFixed(acc, 1))
}

export const $numFormat = (val: string | number, flag: boolean = true) => {
  if (!val || !flag) return val
  const reg = /(\d)(?=(?:\d{3})+$)/g
  const strAry = val.toString().split('.')
  return `${strAry[0].replace(reg, '$1,')}${strAry.length > 1 ? '.' + strAry[1] : ''}`
}

export const $dateFormat = (date: string | undefined, format: string = 'MM-dd hh:mm') => {
  if (!date) return ''
  return (new Date(date) as any).format(format)
}

export const $gt = (val: string | number, next: string | number) => {
  return new BigNumber(val).gt(next)
}

export const $lt = (val: string | number, next: string | number) => {
  return new BigNumber(val).lt(next)
}

export const $minus = (m1: string | number = 0, m2: string | number = 0, decimal: number = 2): number => {
  const diff: any = new BigNumber(m1).minus(m2)
  return Number(diff.toFixed(decimal, 1))
}

export const $div = (m1: string | number = 0, m2: string | number = 0, decimal: number = 2): number => {
  const diff: any = new BigNumber(m1).div(m2)
  return Number(diff.toFixed(decimal, 1))
}

export const $times = (m1: string | number = 0, m2: string | number = 0, decimal: number = 2): number => {
  const diff: any = new BigNumber(m1).times(m2)
  return Number(diff.toFixed(decimal, 1))
}



export const $inputNumber = (): string => {
  return window.innerWidth < 960 ? 'number' : 'text'
}

export const $moreLessThan = (value: string | number, acc = 4) => {
  const val = $BigNumber(value)
  return !val.isZero() && val.isLessThan(0.0001)
    ? '< 0.0001'
    : val.isNaN()
      ? value
      : Number(val.toFormat(acc))
}

export const $hash = (txHash: string, length: number = 4, lastLength?: number) => {
  if (!txHash) {
    return '--'
  }
  if (!lastLength) lastLength = length
  return (
    txHash.substring(0, length) +
      '...' +
      txHash.substring(txHash.length - lastLength, txHash.length)
  )
}

export const scalName = (accountName: string | number): string[] => {
  accountName = 'planowner3'
  let str: any = accountName
  if (typeof (accountName) === 'string') {
    const sb = new Serialize.SerialBuffer({
      textEncoder: new window.TextEncoder(),
      textDecoder: new window.TextDecoder()
    })

    sb.pushName(accountName)
    str = Numeric.binaryToDecimal(sb.getUint8Array(8))
  }

  const pow = $BigNumber(2).pow(64).toFixed()
  const min: any = $BigNumber(str).multipliedBy($BigNumber(2).pow(64).toFixed()).toString(10)
  const max = $BigNumber(min).plus(pow).minus(1).toFixed()

  return [min, max]
}

export const scalName1 = (accountName: string | number): string[] => {
  // accountName = 'planowner3';
  let str: any = accountName
  if (typeof (accountName) === 'string') {
    const sb = new Serialize.SerialBuffer({
      textEncoder: new window.TextEncoder(),
      textDecoder: new window.TextDecoder()
    })

    sb.pushName(accountName)
    str = Numeric.binaryToDecimal(sb.getUint8Array(8))
  }
  return [str]
}

export const sleep = async (time: number): Promise<any> => {
  return await new Promise((resolve) => setTimeout(resolve, time))
}

export const sortArray = (data: any[], ungerKey = 'EOS1111111111111111111111111111111114T1Anm'): any[] => {
  if (!data) {
      return [];
  }
  const result: any[] = [];
  data.sort((a, b) => {
      return b.total_votes - a.total_votes;
  }).forEach((elem, index) => {
      if (elem.producer_key === ungerKey) {
          return;
      }
      const eos_votes = Math.floor(calculateAmaxFromVotes(elem.total_votes)) / 100000000;
      elem.all_votes = Number(eos_votes).toLocaleString();
      // elem.total_votes = Number(eos_votes).toLocaleString();

      result.push(elem);
  });
  return result;
};

export const calculateAmaxFromVotes = (votes: number) => {
  const date = +new Date() / 1000 - 1649083919; // 946... start timestamp
  // if (frontConfig.coin === 'AMAX') {
  //     let weight = parseInt(`${date / (86400 * 7)}`, 10) / 13;
  //     return votes / 2 ** weight / 100000000;
  // }

  const weight = parseInt(`${date / (86400 * 7)}`, 10) / 52; // 86400 = seconds per day 24*3600
  return votes / 2 ** weight / 100000000;
};

export const handleTime = (timestamp?: any):string => {
  if (timestamp) {
    return moment(timestamp.charAt(timestamp.length-1) ==='Z' ? timestamp: (timestamp+'Z')).local().format('YYYY-MM-DD HH:mm:ss');
  }else{
    return ''
  }
};


export const getTokenImg = (imgName:string | undefined) =>{
  if (!imgName) {
    return ''
  }
  return `https://aplink-sh-5.oss-cn-shanghai.aliyuncs.com/explorer/images/${imgName.toLowerCase()}.png`
}

export const convertUTCTimeToLocalTime=(UTCDateString)=> {
  if(!UTCDateString){
    return '-';
  }
  function formatFunc(str) {    //格式化显示
    return str > 9 ? str : '0' + str
  }
  const date2 = new Date(UTCDateString);     //这步是关键
  const year = date2.getFullYear();
  const mon = formatFunc(date2.getMonth() + 1);
  const day = formatFunc(date2.getDate());
  let hour = date2.getHours();
  hour = formatFunc(hour);
  const min = formatFunc(date2.getMinutes());
  const dateStr = year+'-'+mon+'-'+day+' ' +' '+hour+':'+min;
  return dateStr;
}


// console.log(convertUTCTimeToLocalTime('2023-01-18T07:54:10.000Z'),'timetime');

export const handlerDateDuration = (time:string)=> {
  if (!time) {
    return ''
  }
  const d1 = new Date(time)
  const d2 = new Date()
  const cha = d1.getTime() - d2.getTime()
  
  const days = parseInt(cha / (24 * 60 * 60 * 1000))
  const hours = parseInt(cha % (24 * 60 * 60 * 1000) / (60 * 60 * 1000))
  const mins =  parseInt(cha % (60 * 60 * 1000) / (60 * 1000))
  if (days) {
    return `${days}d ${hours > 9 ? hours : `0${hours}`}h ${mins > 9 ? mins : `0${mins}`}m`
  } else if (hours) {
    return `${hours > 9 ? hours : `0${hours}`}h ${mins > 9 ? mins : `0${mins}`}m`
  } else {
    return `${mins}m`
  }
}

export const countSecondsDuration = (time:number)=> {
  const nowtime = new Date(),  //获取当前时间
  endtime = new Date(time);  //定义结束时间
  
  const lefttime = endtime.getTime() - nowtime.getTime(),  //距离结束时间的毫秒数
  leftd = Math.floor(lefttime/(1000*60*60*24)),  //计算天数
  lefth = Math.floor(lefttime/(1000*60*60)%24),  //计算小时数
  leftm = Math.floor(lefttime/(1000*60)%60),  //计算分钟数
  lefts = Math.floor(lefttime/1000%60);  //计算秒数
  if (lefttime > 0) {
    //返回倒计时的字符串
    return (lefth > 9 ? lefth : `0${lefth}`) + ":" + (leftm > 9 ? leftm : `0${leftm}`) + ":" + (lefts > 9 ? lefts : `0${lefts}`); 
  }else{
    return false
  }
   
}

export const bySplit = (quantity:string)=> {
  if (!quantity) {
    return ''
  }
  const splitArr = quantity.split(' ')
  const number = splitArr[0]
  const symbol = splitArr[1]
  return {number,symbol}
}

export const getPrecision = (number:number)=> {
  return number.split('.')[1].length
}

export const timestampToFormat = (timestamp: any,format:string) => {
  if (timestamp) {
    return moment(timestamp).local().format(format);
  }else{
    return ''
  }
};


export const getCurrentLocalTime = () => {
  // 目标时区，东8区
  let targetTimezone = -8
  // 当前时区与中时区时差，以min为维度
  let _dif = new Date().getTimezoneOffset()
  // 本地时区时间 + 时差  = 中时区时间
  // 目标时区时间 + 时差 = 中时区时间
  // 目标时区时间 = 本地时区时间 + 本地时区时差 - 目标时区时差
  // 东8区时间
  let east8time = new Date().getTime() + _dif * 60 * 1000 - (targetTimezone * 60 * 60 * 1000)
  new Date(east8time)
}

export const filterNumberValue = (value: any, decimal: number) => {
  let canStartWithZero = true;
  // if (decimal < 1) {
  //   decimal = this.getDecimalPlaces(decimal);
  // }

  // 清除“数字”和“.”以外的字符
  value = value.replace(/[^\d.]/g, "");
  // 只保留第一个. 清除多余的
  value = value.replace(/\.{2,}/g, ".");
  value = value
    .replace(".", "$#$")
    .replace(/\./g, "")
    .replace("$#$", ".")
    .replace(/^\./, "");

  // 小数位数控制
  // value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
  if (decimal) {
    // new RegExp(`^(\-)*(\d+)\.(\d{1,3}).*$`),
    value = value.replace(
      new RegExp(`^(\\-)*(\\d+)\\.(\\d{${decimal}}).*$`),
      "$1$2.$3"
    );
  } else {
    value = value ? parseInt(value).toString() : "";
  }
  if (!canStartWithZero && value.indexOf(".") < 0 && value != "") {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    value = new BigNumber(value).toFixed();
  }
  return value;
};


export const flatArr = (data:any) => {
  const map = new Map();
  const _newData = data.filter((v:any) => !map.has(v.valueId) && map.set(v.valueId, v));
  return _newData
}

// 千分位转换
export const numFormatThousandths = (num:any) => {
  return (+num || 0).toString().replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
}


export const exportCanvasAsPNG = (id:string, fileName:string) => {
  const canvasElement:any = document.getElementById(id);
  const MIME_TYPE = "image/png";
  const imgURL = canvasElement.toDataURL(MIME_TYPE);

  if (isStarNest) {
    saveImage(imgURL)
  }else{
    const dlLink = document.createElement('a');
    dlLink.download = fileName;
    dlLink.href = imgURL;
    dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');

    document.body.appendChild(dlLink);
    dlLink.click();
    document.body.removeChild(dlLink);
  }
}


export const validateEmail = (email:string) => {
  var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailRegex.test(email);
}


export const getCurrencyByName = (currency:string) =>{
  const currencyList = [
    {
      id: 2,
      name: '美元',
      name_short: 'USD',
      symbol: '$',
      accuracy: 4,
      icon_url: 'https://upload.ibear.link/webcenter/country_icon/us.png',
      is_default: 1,
    },
    {
      id: 3,
      name: '港币',
      name_short: 'HKD',
      symbol: 'HK$',
      accuracy: 2,
      icon_url: 'https://upload.ibear.link/webcenter/country_icon/cn.png',
      is_default: 1,
    },
    {
      id: 4,
      name: '日元',
      name_short: 'JPY',
      symbol: 'JPY¥',
      accuracy: 2,
      icon_url: 'https://upload.ibear.link/webcenter/country_icon/cn.png',
      is_default: 1,
    },
    {
      id: 5,
      name: '韩元',
      name_short: 'KRW',
      symbol: '₩',
      accuracy: 2,
      icon_url: 'https://upload.ibear.link/webcenter/country_icon/cn.png',
      is_default: 1,
    },
    {
      id: 6,
      name: '泰铢',
      name_short: 'THB',
      symbol: '฿',
      accuracy: 2,
      icon_url: 'https://upload.ibear.link/webcenter/country_icon/cn.png',
      is_default: 1,
    },
  ]
  return currencyList.filter((item:any)=>{
    return item.name_short.toLowerCase() === currency
  })[0]
}

export const iframePost = (message:string) =>{
  window.parent.postMessage(message, import.meta.env.VITE_H5_IFRAME);
}

export const isInIframe = () => {
  return window !== window.top;
}

export const redirectMethod = (callback:Function) => {
  if (isInIframe()) {
    iframePost('redirect:home')
  }else{
    if (isStarNest) {
      callback()
      webviewClose()
    }else{
      showToast('当前环境不支持跳转,请手动返回')
    }
  }
}

// 更新倒计时函数
export const updateCountdown = (timeStamp: number, intervalId?: any) => {
  const countdownTime = moment(timeStamp);
  const now = moment();
  const duration = countdownTime.diff(now);

  if (duration < 0) {
    // 倒计时结束
    console.log("Countdown finished.");
    clearInterval(intervalId);
    return "0";
  } else {
    // 显示剩余时间
    const durationObj = moment.duration(duration);
    const days = durationObj.days();
    const hours = durationObj.hours();
    const minutes = durationObj.minutes();
    const seconds = durationObj.seconds(); // 传入参数 true 以获取秒数的小数部分
    return `${days > 0 ? `${days}d ` : `` }${hours > 9 ? hours : `0${hours}`}h${
      minutes > 9 ? minutes : `0${minutes}`
    }m${seconds > 9 ? seconds : `0${seconds}`}s`;
  }
};


export function getLoginToken():LoginToken | string | undefined {
  const accessToken = (window as any).APLINK_STARNEST?.token;
  const account = (window as any).APLINK_STARNEST?.account;
  if (accessToken) {
    return {
      accessToken,
      account,
    };
  }
  const token = sessionStorage.getItem('APLINK_STARNEST_TOKEN');

  if (token) {
    return token;
  }
}